import * as React from "react";
import { Dropdown, Form } from "react-bootstrap";
import { FiChevronDown } from "react-icons/fi";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import OutsideClickHandler from "react-outside-click-handler";
import { ISingleSearchDropdownListProps } from "../Contracts/ISingleSearchDropdownListProps";
import { AnyARecord } from "dns";

export class MultiSelectDropdownList extends React.Component<any, any> {
  private inputElement: any;
  private listDiv: any;
  private toggleRef: any;

  constructor(props: any) {
    super(props);
    this.inputElement = React.createRef();
    this.listDiv = React.createRef();
    this.toggleRef = React.createRef();

    this.state = {
      defaultSelectedName: props.defaultName,
      filterData: this.props.itemList,
      itemList: this.props.itemList,
      inputValue: "",
      searchText: props.defaultText,
      controlID: props.controlID,
      isdisable: this.props?.isdisable || false,
      showIcon: this.props?.showIcon || false,
      pageType: props.pageType,
      isStatusbadge: props.isStatusbadge,
      selectedNames: [],  // Changed from `selectedItems` to `selectedNames`
      searchid:this.props.searchid
    };

    this.handleChange = this.handleChange.bind(this);
    this.resetSerchBox = this.resetSerchBox.bind(this);
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
  }

  handleChange(e: any) {
    const updatedList = this.state.itemList.filter((item: any) => {
      return item.name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1;
    });
    this.setState({ filterData: updatedList, inputValue: e.target.value });
  }

  handleDropdownChange = (item: any) => {
    this.setState((prevState: any) => {
      let updatedNames = [...prevState.selectedNames];
  
      if (item.name === "All") {
        // Reset selection if "All" is clicked
        updatedNames = [];
      } else {
        // Toggle selection
        updatedNames = updatedNames.includes(item.name)
          ? updatedNames.filter((name) => name !== item.name)
          : [...updatedNames, item.name];
      }
  
      return { selectedNames: updatedNames };
    }, () => {
      // Call the handleSelectedItem function if defined
      if (typeof this.props.handleSelectedItem === "function") {
        this.props.handleSelectedItem(this.state.selectedNames, this.state.controlID);
      }
    });
  };
  


  resetSerchBox = () => {
    this.setState({ inputValue: "", filterData: this.state.itemList });
  };

  resetddlItem = (key: any, isdisable: any) => {
    this.setState({ inputValue: "", defaultSelectedName: key, isdisable: isdisable });
  };

  componentDidUpdate(prevProps) {
    if (prevProps?.isRefresh !== this.props?.isRefresh) {
      this.setState({ inputValue: "", defaultSelectedName: this.props.defaultName });
    }

    if (prevProps?.isdisable !== this.props?.isdisable) {
      this.setState({ isdisable: this.props?.isdisable || false });
    }

    if(prevProps.itemList !== this.props.itemList){
      console.log("this.props.itemList ===> ", this.props.itemList);
      this.setState({itemList: this.props.itemList})
    }
  }

  placeHolderList = ["Select an asset", "Select a technician", "Select"];

  handleSearchItem = (event: any, type: any) => {
    let searchval = event.target.value.trimStart();
    if (type === "Room Type") {
      if (searchval !== "") {
        const roomTypeData = [...this.state.itemList];
        const updatefilterState = roomTypeData.filter((o: any) => {
          return (
            o.name.toLowerCase().indexOf(searchval.toLowerCase()) > -1
          )
        });
        this.setState({ itemList: updatefilterState, searchText: searchval,  searchid: searchval });
      } else {
        this.setState({ itemList: this.props.itemList, searchText: searchval,  searchid: searchval })
      }
    }
  }

  ehidCheckLabel = (item: any) => (<>{(item.name)}</>);

  resetSearchValue = () => {
    this.setState({ searchid: "" });
  };

  render() {
    const { isEHIDPlaceholder } = this.props;
    const { itemList, searchText } = this.state;
    if (this.props.shouldReset) {
      this.resetSearchValue();
    }

    const isSelected = itemList?.find(item => item.isChecked);
    return (
      <>
        <OutsideClickHandler
          key="outsideclick"
          onOutsideClick={this.resetSerchBox}
        >
          <Dropdown
            // onToggle={() => this.handleDDToggle("Room Type")}
            className="drop-down-select ehid-selector"
          // onSelect={(event: any) => this.handleDropSelect(event, "ehid")}
          >
            <Dropdown.Toggle id="groups-dropdown" className="border-0">
              <div className='d-flex flex-class align-items-center'>
                <div className={`selected-val ${isSelected ? "selected" : "" }`}><EllipsisWithTooltip placement="bottom">{isEHIDPlaceholder}</EllipsisWithTooltip></div>
                <div className='arrow ml-auto'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 12.8124L5 7.81242L6.16667 6.64575L10 10.4791L13.8333 6.64575L15 7.81242L10 12.8124Z" fill="#1D1E20" />
                  </svg>
                </div>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ "width": "250px" }}>
              <div className="SearchControl commSearchControl">
                <Form.Control type="text"
                  className="comm-search-input"
                  name="searchItems"
                  id="searchItemsFrom"
                  value={this.state.searchid}
                  autoComplete="off"
                  onChange={(e: any) => this.handleSearchItem(e, 'Room Type')}
                  placeholder="Search..."
                />
              </div>
              {itemList?.length === 0 && this.state.searchText && (
                <div className="footer small p-2 pl-3">
                  <span>No data found</span>
                </div>
              )}
              <div className="ListItems ListWithMultiSelect">
                {(itemList || []).map((item: any, idx: any) => (
                  <>
                    <div className="dropdownItems border-0" key={item.id}>
                      <Form.Check
                        type="checkbox"
                        id={`checkId_${item.id}`}
                        name={item.name}
                        label={this.ehidCheckLabel(item)}
                        value={item.id}
                        onChange={(event) => this.props.itemCheckChange(event, item, this.state.controlID)}
                        checked={item.isChecked}
                      />
                      <EllipsisWithTooltip placement="bottom">{this.ehidCheckLabel(item)}</EllipsisWithTooltip>
                    </div>
                  </>
                ))}
              </div>
              {itemList.length > 0 && (
                <div className="selectClearAll isHideCheck dropdownItems d-block">
                  <Form.Check
                    type="checkbox"
                    id={`itemSelectAllEhid_${this.state.controlID}`}
                    label={itemList.some(o => o.isChecked === false) ? "Select All" : "Clear All"}
                    value={itemList.some(o => o.isChecked === false) ? "selectAll" : "clearAll"}
                    onChange={(event) => this.props.hanldeItemSelectAll(event, this.state.controlID)}
                    checked={itemList.some(o => o.isChecked === false) ? false : true}
                  />
                </div>
              )}
            </Dropdown.Menu>
          </Dropdown>
          {/* <div className={`pip ${this.props.isShowPip ? this.state.defaultSelectedName.toLowerCase() : "" } ${this.placeHolderList.map((e) => e === this.state.defaultSelectedName ? " placeholder-color " : "")} `}>
              <Dropdown
                tabIndex={0}
                className="more-action bg-blue single-select-image"
                onSelect={hidSelectModal}
                onClick={onFocusInput}
                onKeyUp={(e) => onTabKeyDown(e)}
              >
                <Dropdown.Toggle ref={this.toggleRef} id="Modal-hid" className="filter-btn" disabled={this.state?.isdisable || this.props?.isFromRepeating}>
                  <div className="d-flex align-items-center">
                    {this.state.showIcon ? 
                      <div className={`pr-1 search-icon-visibility `}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                          <path d="M5.66634 11.0002C6.84966 10.9999 7.99888 10.6038 8.93101 9.87483L11.8617 12.8055L12.8043 11.8628L9.87368 8.93216C10.603 7.99994 10.9994 6.85045 10.9997 5.66683C10.9997 2.72616 8.60701 0.333496 5.66634 0.333496C2.72567 0.333496 0.333008 2.72616 0.333008 5.66683C0.333008 8.6075 2.72567 11.0002 5.66634 11.0002ZM5.66634 1.66683C7.87234 1.66683 9.66634 3.46083 9.66634 5.66683C9.66634 7.87283 7.87234 9.66683 5.66634 9.66683C3.46034 9.66683 1.66634 7.87283 1.66634 5.66683C1.66634 3.46083 3.46034 1.66683 5.66634 1.66683Z" fill="#84888C"/>
                        </svg>
                      </div>
                      : <></>
                    }
                    <div className="txt-area">
                      <EllipsisWithTooltip placement="bottom">
                        {this.state.selectedNames.join(", ") || this.state.defaultSelectedName}
                      </EllipsisWithTooltip>
                    </div>
                    <div className="drop-arrow ml-0 d-flex">
                      <FiChevronDown />
                    </div>
                  </div>
                </Dropdown.Toggle>
  
                <Dropdown.Menu>
                  {(this.props?.allowSearch || this.props?.allowSearch === undefined) &&
                  <div className="search-sec">
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChange}
                      placeholder={this.state.searchText}
                      value={this.state.inputValue}
                      ref={this.inputElement}
                      autoFocus={true}
                    />
                  </div>}
                  <div className="list-area" ref={this.listDiv}>
                    {this.state.filterData.map((item: any, idx: any) => {
                      let isStatusDevider = item?.status === "isDevider";
                      let isLabelSyncd = item?.status === "isLabelSyncd";
                      let isLabelOther = item?.status === "isLabelOther";
                      return (
                        <>
                          {(idx > 0 && this.state.filterData.length > 0 && (item?.hotelType !== this.state.filterData[idx - 1]?.hotelType || isStatusDevider)) && (
                            <Dropdown.Divider />
                          )}
                          {isBothSO && (
                            <>
                              {isLabelSyncd && (<div className="syncDropdownHeader divider">{item?.bName}</div>)}
                              {isLabelOther && (<div className="syncDropdownHeader divider">{item?.bName}</div>)}
                            </>
                          )}
                          {(!isStatusDevider && !isLabelSyncd && !isLabelOther)  && (
                            <Dropdown.Item
                              disabled={item.disabled}
                              eventKey={item.name}
                              onClick={() => this.handleDropdownChange(item)}
                              key={idx}
                            >
                              <div className="d-flex">
                                <div className={(this.state.isStatusbadge && item.status?.toString().toLowerCase() === "inactive") ? "mr-auto item inactive" : "mr-auto item"}>
                                  <EllipsisWithTooltip placement="bottom">{item.name}</EllipsisWithTooltip>
                                </div>
                                {(this.state.isStatusbadge && item.status?.toString().toLowerCase() === "inactive") && (
                                  <div className="badge grey-bg">Inactive</div>
                                )}
                              </div>
                            </Dropdown.Item>
                          )}
                          {(this.state.filterData.length > 0 && this.state.filterData[idx - 1]?.orderno === 1 && item?.orderno === 2) && (
                            <hr />
                          )}
                        </>
                      )
                    })}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div> */}
        </OutsideClickHandler>
      </>
    );
  }
}
